import template from './carrier.create.html';
import controller from './carrier.create.controller';
import './carrier.create.controller';

let carriercreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default carriercreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/carrier/create/carrier.create.component.js